// You can write more code here

/* START OF COMPILED CODE */

import EntityMoney from './EntityMoney';
/* START-USER-IMPORTS */
import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import { Vehicle } from '../../vehicle/Vehicle';
import { GameDataHandler } from '../../GameDataHandler';
import { VehicleVillain } from '../../vehicle/VehicleVillain';
/* END-USER-IMPORTS */

export default class MoneySuperBag extends EntityMoney {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 38, y ?? 26.5);

    // shadow
    const shadow = scene.add.image(0, 0, 'game', 'cash-bag-shadow.png');
    this.add(shadow);

    // money
    const money = scene.add.image(0, -395, 'game', 'present.png');
    this.add(money);

    this.shadow = shadow;
    this.money = money;

    /* START-USER-CTR-CODE */
    this.boundsExtension = 20;
    let diff = this.money.y - this.shadow.y;

    this.setSize(this.money.width, this.money.height);
    this.injectMatter(this, this.x, this.y, this.shadow.width + this.boundsExtension, diff + this.boundsExtension);
    this.setupParticles();

    this.scene.add.tween({
      targets: [this.shadow, this.money],
      scaleX: 1.1,
      scaleY: 1.1,
      duration: 500,
      yoyo: true,
      repeat: -1
    });
    /* END-USER-CTR-CODE */
  }

  private shadow: Phaser.GameObjects.Image;
  private money: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  private particles!: Phaser.GameObjects.Particles.ParticleEmitterManager;

  public canCollect(Vehicle: Vehicle): boolean {
    return Vehicle.IsAirborne;
  }

  public dropMoney(vehicle: VehicleVillain) {
    this.throwTo(vehicle, this.money, this.shadow);
  }

  protected setupParticles() {
    this.particles = this.scene.make.particles(
      {
        key: 'common',
        emitters: [
          {
            name: 'explode',
            on: false,
            frame: ['batsymbol-yellow.png'],
            // x: -960,
            // y: -400,
            angle: { min: -200, max: 0 },
            //scale: { min: 0.5, max: 2.0 },
            rotate: { min: 0, max: 360 },
            scale: { start: 0.5, end: 0.8, ease: Phaser.Math.Easing.Cubic.Out },
            alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Cubic.In },
            speed: { min: 200, max: 700 },
            gravityY: 600,
            lifespan: 1500,
            quantity: 1
            //emitZone: { source: new Phaser.Geom.Circle(0,0,200) }
          }
        ]
      },
      false
    );
    this.scene.add.existing(this.particles);
  }

  protected score(vehicle: Vehicle): void {
    app.audioHandler.playSound(this.scene, vehicle.sounds.cheer, Sounds.Channel.SFX, { volume: 1.0 });
    app.audioHandler.playSound(this.scene, Sounds.Track.Pickup2, Sounds.Channel.SFX, { volume: 1.0 });
    this.scene.registry.inc(GameDataHandler.keys.Score, 10);

    let emitter = this.particles.emitters.getByName('explode');
    emitter?.explode(40, this.x, this.y + this.money.y);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
